import { defineComponent as _defineComponent } from 'vue';
import { ref, watch } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ClickToEdit',
    props: {
        value: null,
        title: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const editable = ref(false);
        const localValue = ref(props.value);
        watch(() => localValue.value, (newLocalValue) => {
            emit("input", newLocalValue);
        });
        watch(() => props.value, (newValue) => {
            localValue.value = newValue;
        });
        return { __sfc: true, props, emit, editable, localValue };
    }
});
